import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { postFinanciera } from "../helpers/rutaFinancieras";

const estadoInicial = {
  financiera: "",
  razonsocial: "",
  cuit: "",
  domicilio: "",
  telefono1: "",
  email: "",
  contacto: "",
  observaciones: "",
  activo: true,
};

const clean = (v) => String(v ?? "").trim();

const AddFinancieraForm = () => {
  const history = useHistory();

  const [formValues, setFormValues] = useState(estadoInicial);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validar = () => {
    const financiera = clean(formValues.financiera);

    if (!financiera) return "Completá el nombre de la financiera.";

    return "";
  };

  const armarPayload = () => ({
    financiera: clean(formValues.financiera),
    razonsocial: clean(formValues.razonsocial),
    cuit: clean(formValues.cuit),
    domicilio: clean(formValues.domicilio),
    telefono1: clean(formValues.telefono1),
    email: clean(formValues.email),
    contacto: clean(formValues.contacto),
    observaciones: clean(formValues.observaciones),
    activo: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setOk("");

    const msg = validar();

    if (msg) {
      setError(msg);
      return;
    }

    try {
      setSaving(true);

      await postFinanciera(armarPayload());

      setOk("Financiera guardada correctamente.");
      setFormValues(estadoInicial);
    } catch (err) {
      console.error("❌ Error guardando financiera:", err);

      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo guardar la financiera."
      );
    } finally {
      setSaving(false);
    }
  };

  const volver = () => {
    history.goBack();
  };

  return (
    <div className="container mt-4 mb-5">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">Alta de Financiera</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card-body">
            {error && (
              <div className="alert alert-danger py-2" role="alert">
                {error}
              </div>
            )}

            {ok && (
              <div className="alert alert-success py-2" role="alert">
                {ok}
              </div>
            )}

            <h6 className="border-bottom pb-2 mb-3">Datos principales</h6>

            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Financiera *</label>
                <input
                  type="text"
                  className="form-control"
                  name="financiera"
                  value={formValues.financiera}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Razón social</label>
                <input
                  type="text"
                  className="form-control"
                  name="razonsocial"
                  value={formValues.razonsocial}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">CUIT</label>
                <input
                  type="text"
                  className="form-control"
                  name="cuit"
                  value={formValues.cuit}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-8">
                <label className="form-label">Domicilio</label>
                <input
                  type="text"
                  className="form-control"
                  name="domicilio"
                  value={formValues.domicilio}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>
            </div>

            <h6 className="border-bottom pb-2 mt-4 mb-3">Contacto</h6>

            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">Teléfono</label>
                <input
                  type="text"
                  className="form-control"
                  name="telefono1"
                  value={formValues.telefono1}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formValues.email}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Contacto</label>
                <input
                  type="text"
                  className="form-control"
                  name="contacto"
                  value={formValues.contacto}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>
            </div>

            <h6 className="border-bottom pb-2 mt-4 mb-3">Observaciones</h6>

            <div className="row g-3">
              <div className="col-md-12">
                <label className="form-label">Observaciones</label>
                <textarea
                  className="form-control"
                  name="observaciones"
                  value={formValues.observaciones}
                  onChange={handleChange}
                  disabled={saving}
                  rows={3}
                />
              </div>
            </div>
          </div>

          <div className="card-footer d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={volver}
              disabled={saving}
            >
              Volver
            </button>

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Guardando..." : "Guardar Financiera"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFinancieraForm;